let IssueNfeDomainService = require("../../../Domain/Service/IssueNfe/IssueNfeDomainService");

async function issueNfe(sales) {
  try {
    return await IssueNfeDomainService.execute(sales);
  } catch (error) {
    return error;
  }
}

module.exports = { issueNfe };
